module.exports = __webpack_public_path__ + "img/20191101170027376.4760fe78.jpg";